import { render, staticRenderFns } from "./SurveyComponent.vue?vue&type=template&id=60ed3140&scoped=true&"
import script from "./SurveyComponent.vue?vue&type=script&lang=js&"
export * from "./SurveyComponent.vue?vue&type=script&lang=js&"
import style0 from "./SurveyComponent.vue?vue&type=style&index=0&id=60ed3140&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed3140",
  null
  
)

export default component.exports